export default "__VITE_ASSET__D$QzwWqa__"